import { render, staticRenderFns } from "./newUser.vue?vue&type=template&id=150770ee&"
import script from "./newUser.vue?vue&type=script&lang=js&"
export * from "./newUser.vue?vue&type=script&lang=js&"
import style0 from "./newUser.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports